/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_LanguageInputs */

const en_marketing_language = /** @type {(inputs: Marketing_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const es_marketing_language = /** @type {(inputs: Marketing_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const fr_marketing_language = /** @type {(inputs: Marketing_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Marketing_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_language = /** @type {((inputs?: Marketing_LanguageInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_LanguageInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_language(inputs)
	if (locale === "es") return es_marketing_language(inputs)
	return fr_marketing_language(inputs)
});